import { render, staticRenderFns } from "./LikeCollectionComponent.vue?vue&type=template&id=5d63edb2&scoped=true"
import script from "./LikeCollectionComponent.vue?vue&type=script&lang=js"
export * from "./LikeCollectionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d63edb2",
  null
  
)

export default component.exports